export default "__VITE_ASSET__Du9tC68K__"